import { APP_TYPES } from "./AppTypes";

// Scrawl
import ScrawlLogo from "images/games/ScrawlLogo.png";
import ScrawlStoreBackground from "images/storeBackgrounds/scrawl.png";
import ScrawlStoreLogo from "images/storeLogos/scrawl.png";
import ScrawlCardLogo from "images/gameCards/logo/scrawl.png";
import ScrawlCardBackground from "images/gameCards/background/scrawl.jpg";
import ScrawlMobilePreview1 from "images/gameStorePreviews/scrawl/scrawl-mobile-1.png";
import ScrawlMobilePreview2 from "images/gameStorePreviews/scrawl/scrawl-mobile-2.png";
import ScrawlDesktopPreview1 from "images/gameStorePreviews/scrawl/scrawl-tv-ls.png";
import ScrawlDesktopPreview2 from "images/gameStorePreviews/scrawl/scrawl-desktop-2.png";
import ScrawlTinyCard from "images/tinyCards/Scrawl.png";

// Herd Mentality
import HerdLogo from "images/games/HerdLogo.png";
import HerdStoreBackground from "images/storeBackgrounds/herdMentality.png";
import HerdStoreLogo from "images/storeLogos/herdMentality.png";
import HerdCardLogo from "images/gameCards/logo/herdMentality.png";
import HerdCardBackground from "images/gameCards/background/herdMentatlity.jpg";
import HerdMobilePreview1 from "images/gameStorePreviews/herd/herd-mobile-1.png";
import HerdMobilePreview2 from "images/gameStorePreviews/herd/herd-mobile-2.png";
import HerdDesktopPreview1 from "images/gameStorePreviews/herd/herd-desktop-1.png";
import HerdDesktopPreview2 from "images/gameStorePreviews/herd/herd-hero.png";
import HerdTinyCard from "images/tinyCards/Herd Mentality.png";

// Can Of Squirms
import SquirmsLogo from "images/games/SquirmsLogo.png";
import SquirmsStoreBackground from "images/storeBackgrounds/squirms.png";
import SquirmsStoreLogo from "images/storeLogos/squirms.png";
import SquirmsCardLogo from "images/gameCards/logo/canOfSquirms.png";
import SquirmsCardBackground from "images/gameCards/background/canOfSquirms.jpg";
import SquirmsMobilePreview1 from "images/gameStorePreviews/squirms/squirms-mobile-1.png";
import SquirmsMobilePreview2 from "images/gameStorePreviews/squirms/squirms-mobile-2.png";
import SquirmsDesktopPreview1 from "images/gameStorePreviews/squirms/squirms-tv-ls.png";
import SquirmsDesktopPreview2 from "images/gameStorePreviews/squirms/squirms-desktop-2.png";
import SquirmsTinyCard from "images/tinyCards/Can of Squirms.png";

// Draw With Dave
import DrawWithLogo from "images/games/DrawWithLogo.png";
import DrawWithStoreBackground from "images/storeBackgrounds/drawWith.png";
import DrawWithStoreLogo from "images/storeLogos/drawWith.png";
import DrawWithCardLogo from "images/gameCards/logo/drawWith.png";
import DrawWithCardBackground from "images/gameCards/background/drawWith-v2.jpg";
import DrawWithMobilePreview1 from "images/gameStorePreviews/drawWith/drawwith-mobile-1.png";
import DrawWithMobilePreview2 from "images/gameStorePreviews/drawWith/drawwith-mobile-2.png";
import DrawWithDesktopPreview1 from "images/gameStorePreviews/drawWith/drawwith-desktop-1.png";
import DrawWithDesktopPreview2 from "images/gameStorePreviews/drawWith/drawwith-desktop-2.png";
import DaveTinyCard from "images/tinyCards/Draw Along with Dave.png";

// The Chameleon
import ChameleonLogo from "images/games/ChameleonLogo.png";
import ChameleonStoreBackground from "images/storeBackgrounds/theChameleon.png";
import ChameleonStoreLogo from "images/storeLogos/theChameleon.png";
import ChameleonCardLogo from "images/gameCards/logo/theChameleon.png";
import ChameleonCardBackground from "images/gameCards/background/theChameleon.jpg";
import ChameleonMobilePreview1 from "images/gameStorePreviews/theChameleon/chameleon-mobile-1.png";
import ChameleonMobilePreview2 from "images/gameStorePreviews/theChameleon/chameleon-mobile-2.png";
import ChameleonDesktopPreview1 from "images/gameStorePreviews/theChameleon/chameleon-desktop-1.png";
import ChameleonDesktopPreview2 from "images/gameStorePreviews/theChameleon/chameleon-desktop-2.png";
import ChameleonTinyCard from "images/tinyCards/The Chameleon.png";

// Colour Brain
import ColourBrainLogo from "images/games/ColourBrainLogo.png";
import ColourBrainStoreBackground from "images/storeBackgrounds/colourBrain.png";
import ColourBrainStoreLogo from "images/storeLogos/colourBrain.png";
import ColourBrainCardLogo from "images/gameCards/logo/colourBrain.png";
import ColourBrainCardLogoJunior from "images/gameCards/logo/colourBrainJuniorLogo.png";
import ColourBrainCardBackground from "images/gameCards/background/colourBrain.jpg";
import ColourBrainMobilePreview1 from "images/gameStorePreviews/colourBrain/colourbrain-mobile-1.png";
import ColourBrainMobilePreview2 from "images/gameStorePreviews/colourBrain/colourbrain-mobile-2.png";
import ColourBrainDesktopPreview1 from "images/gameStorePreviews/colourBrain/colourbrain-desktop-1.png";
import ColourBrainDesktopPreview2 from "images/gameStorePreviews/colourBrain/colourbrain-desktop-2.png";
import ColourBrainTinyCard from "images/tinyCards/Colourbrain.png";

// Anagram Magic
import AnagramMagicLogo from "images/games/anagram-magic-logo.png";
import AnagramMagicCardLogo from "images/gameCards/logo/anagram-magic-shop-logo.png";
import AnagramMagicBackground from "images/storeBackgrounds/anagram-magic-background.png";
import AnagramMagicMobilePreview1 from "images/gameStorePreviews/brainGames/anagramMagic/anagramMagic-mobile-1.png";
import AnagramMagicMobilePreview2 from "images/gameStorePreviews/brainGames/anagramMagic/anagramMagic-mobile-2.png";
import AnagramMagicDesktopPreview1 from "images/gameStorePreviews/brainGames/anagramMagic/anagramMagic-desktop-1.png";
import AnagramMagicDesktopPreview2 from "images/gameStorePreviews/brainGames/anagramMagic/anagramMagic-desktop-2.png";
import AnagramMagicTinyCard from "images/tinyCards/anagram-magic-tinycard.png";

// Maths Master
import MathsMasterLogo from "images/games/maths-master-logo.png";
import MathsMasterCardLogo from "images/gameCards/logo/maths-master-shop-logo.png";
import MathsMasterBackground from "images/storeBackgrounds/maths-master-background.png";
import MathsMasterMobilePreview1 from "images/gameStorePreviews/brainGames/mathsMaster/mathsMaster-mobile-1.png";
import MathsMasterMobilePreview2 from "images/gameStorePreviews/brainGames/mathsMaster/mathsMaster-mobile-2.png";
import MathsMasterDesktopPreview1 from "images/gameStorePreviews/brainGames/mathsMaster/mathsMaster-desktop-1.png";
import MathsMasterDesktopPreview2 from "images/gameStorePreviews/brainGames/mathsMaster/mathsMaster-desktop-2.png";
import MathsMasterTinyCard from "images/tinyCards/maths-master-tinycard.png";

// Word Wheel
import WordWheelLogo from "images/games/word-wheel-logo.png";
import WordWheelCardLogo from "images/gameCards/logo/word-wheel-shop-logo.png";
import WordWheelBackground from "images/storeBackgrounds/word-wheel-background.png";
import WordWheelMobilePreview1 from "images/gameStorePreviews/brainGames/wordWheel/wordWheel-mobile-1.png";
import WordWheelMobilePreview2 from "images/gameStorePreviews/brainGames/wordWheel/wordWheel-mobile-2.png";
import WordWheelDesktopPreview1 from "images/gameStorePreviews/brainGames/wordWheel/wordWheel-desktop-1.png";
import WordWheelDesktopPreview2 from "images/gameStorePreviews/brainGames/wordWheel/wordWheel-desktop-2.png";
import WordWheelTinyCard from "images/tinyCards/word-wheel-tinycard.png";

// Pub Quiz
import PubQuizLogo from "images/games/PubQuizLogo.png";
import PubQuizStoreBackground from "images/storeBackgrounds/pubQuiz.jpg";
import PubQuizStoreLogo from "images/games/PubQuizLogo.png";
import PubQuizCardLogo from "images/gameCards/logo/pubQuiz.png";
import PubQuizCardBackground from "images/gameCards/background/pubQuiz.jpg";
import PubQuizMobilePreview1 from "images/gameStorePreviews/pubQuiz/pubquiz-mobile-1.png";
import PubQuizMobilePreview2 from "images/gameStorePreviews/pubQuiz/pubquiz-mobile-2.png";
import PubQuizDesktopPreview1 from "images/gameStorePreviews/pubQuiz/pubquiz-desktop-1.png";
import PubQuizDesktopPreview2 from "images/gameStorePreviews/pubQuiz/pubquiz-desktop-2.png";
import PubQuizTinyCard from "images/tinyCards/pub-quiz-tinycard.png";


// YCSU
import YCSULogo from "images/games/ycsu-logo.png";
import YCSUStoreBackground from "images/storeBackgrounds/round-BG-pink.png";
import YCSUStoreLogo from "images/games/ycsu-logo.png";
import YCSUCardLogo from "images/games/ycsu-logo.png";
import YCSUCardBackground from "images/gameCards/background/ycsu-cardBG.jpg";
import YCSUMobilePreview1 from "images/gameStorePreviews/ycsu/ycsu-mobile-1.png";
import YCSUMobilePreview2 from "images/gameStorePreviews/ycsu/ycsu-mobile-2.png";
import YCSUDesktopPreview1 from "images/gameStorePreviews/ycsu/ycsu-desktop-2.png";
import YCSUDesktopPreview2 from "images/gameStorePreviews/ycsu/ycsu-desktop-1.png";
import YCSUTinyCard from "images/tinyCards/YCSU.png"; //TODO need ycsu timy card

// Catchphrase
import CatchphraseLogo from "images/games/CatchphraseLogo.png";
import CatchphraseBackground from "images/storeBackgrounds/CatchphraseBG.jpg";
import CatchphraseCardBackground from "images/gameCards/background/CatchphraseBG.jpg";
import CatchphraseMobilePreview1 from "images/gameStorePreviews/catchphrase/catchphrase-mobile-1.png";
import CatchphraseMobilePreview2 from "images/gameStorePreviews/catchphrase/catchphrase-mobile-2.png";
import CatchphraseDesktopPreview1 from "images/gameStorePreviews/catchphrase/catchphrase-desktop-1.jpg";
import CatchphraseDesktopPreview2 from "images/gameStorePreviews/catchphrase/catchphrase-desktop-2.jpg";
import CatchphraseTinyCard from "images/tinyCards/catchphrase-tiny-card.png";

// UC
import UCLogo from "images/games/UC-Logo.png";
import UCCardLogo from "images/gameCards/logo/uc.png";
import UCStoreBackground from "images/storeBackgrounds/uc.jpg";
import UCCardBackground from "images/gameCards/background/uc.jpg";
import UCMobilePreview1 from "images/gameStorePreviews/uc/uc-mobile-1.png";
import UCMobilePreview2 from "images/gameStorePreviews/uc/uc-mobile-2.png";
import UCDesktopPreview1 from "images/gameStorePreviews/uc/uc-desktop-1.png";
import UCDesktopPreview2 from "images/gameStorePreviews/uc/uc-desktop-2.png";
import UCTinyCard from "images/tinyCards/uc-tinycard.png";

// Poker
import PokerNightLogo from "images/games/pokernight-logo1.png";
import PokerNightCardLogo from "images/gameCards/logo/pokernight-logo2.png";
import PokerNightStoreBackground from "images/storeBackgrounds/pokernight-backer1.jpg";
import PokerNightCardBackground from "images/gameCards/background/pokernight-backer2.jpg";
import PokerNightMobilePreview1 from "images/gameStorePreviews/poker/poker-mobile-1.jpg";
import PokerNightMobilePreview2 from "images/gameStorePreviews/poker/poker-mobile-2.jpg";
import PokerNightDesktopPreview1 from "images/gameStorePreviews/poker/poker-desktop-1.jpg";
import PokerNightDesktopPreview2 from "images/gameStorePreviews/poker/poker-desktop-2.jpg";
import PokerNightTinyCard from "images/tinyCards/pokernight-tinycard.png";


// PWFS
import PWFLogo from "images/gameStorePreviews/pwf/PWFLogoSmall.png";
import PWFLogoLarge from "images/gameStorePreviews/pwf/PWFLogo.png";
import PWFMetal from "images/gameStorePreviews/pwf/MetalModal.png";
import PWFGame from "images/gameStorePreviews/pwf/PWFScreenshot.png"
import PWFbackground from "images/gameStorePreviews/pwf/Background.png"
import pwfShineLogo from "images/gameStorePreviews/pwf/PWFLogoShine.gif"
import BombAnimationOnLoop from "images/gameStorePreviews/pwf/BombAnimationLoopSmall.gif"
import PWFTinyCard from "images/tinyCards/PWF-TinyCard.png";

import PWFGame2 from "images/gameStorePreviews/pwf/PWFTVGraphic.png"
import pwfBackground2 from 'images/gameStorePreviews/pwf/MainMenu.png'

// POOL 
import PoolLogo from "images/games/PoolHall_Logo.png";
import PoolShopLogo from "images/gameCards/logo/pool-hall-shop-logo.png";
import PoolHallCardBackground from "images/gameCards/background/PoolHall_Background.jpg";
import PoolDesktopPreview1 from "images/gameStorePreviews/Pool/pool-desktop-1.jpg";
import PoolDesktopPreview2 from "images/gameStorePreviews/Pool/pool-desktop-2.jpg";
import PoolStorePagePreview from "images/gameStorePreviews/Pool/StorePage_Promo.jpg";
import PoolGameplayPreview from "images/gameStorePreviews/Pool/pool-desktop-2.jpg";

// OPC
import OPCLogo from "images/games/OPC-logo.png";
import OPCStoreBackground from "images/storeBackgrounds/OPC.jpg";
import OPCStoreLogo from "images/storeLogos/OPC.png";
import OPCCardLogo from "images/gameCards/logo/opc_shop_card_logo.png";
import OPCCardBackground from "images/gameCards/background/opc-background.jpg";
import OPCMobilePreview1 from "images/gameStorePreviews/opc/opc-mobile-1.jpg";
import OPCMobilePreview2 from "images/gameStorePreviews/opc/opc-mobile-2.jpg";
import OPCDesktopPreview1 from "images/gameStorePreviews/opc/opc-desktop-1.jpg";
import OPCDesktopPreview2 from "images/gameStorePreviews/opc/opc-desktop-2.jpg";
import OPCTinyCard from "images/tinyCards/OPC-tinycard.png";



// MDMD
import MDMDLogo from "images/games/MDMD-Logo.png";
import MDMDStoreBackground from "images/storeBackgrounds/MDMD.jpg";
import MDMDStoreLogo from "images/storeLogos/MDMD.png";
import MDMDCardLogo from "images/gameCards/logo/MDMD-Logo.png";
import MDMDCardBackground from "images/gameCards/background/MDMD-background.jpg";
import MDMDMobilePreview1 from "images/gameStorePreviews/mdmd/MDMD-mobile-1.jpg";
import MDMDMobilePreview2 from "images/gameStorePreviews/mdmd/MDMD-mobile-2.jpg";
import MDMDDesktopPreview1 from "images/gameStorePreviews/mdmd/MDMD-desktop-1.jpg";
import MDMDDesktopPreview2 from "images/gameStorePreviews/mdmd/MDMD-desktop-2.jpg";
import MDMDTinyCard from "images/tinyCards/MDMD-tinycard.png";

// IPT
import IPTLogo from "images/gameCards/logo/IPTLogo.png";
import IPTStoreLogo from "images/storeLogos/IPT.png";
import IPTBackground from "images/storeBackgrounds/IPTBackground.jpg";
import IPTStoreBackground from "images/storeBackgrounds/IPT.jpg";
import IPTMobilePreview1 from "images/gameStorePreviews/IPT/Mobile1.jpg"
import IPTMobilePreview2 from "images/gameStorePreviews/IPT/Mobile2.jpg"
import IPTDesktopPreview1 from "images/gameStorePreviews/IPT/Desktop1.jpg"
import IPTDesktopPreview2 from "images/gameStorePreviews/IPT/Desktop2.jpg"
import IPTTinyCard from "images/tinyCards/IPT.jpg"


// DOND
import DONDLogo from "images/games/DOND-Logo.png";
import DONDStoreBackground from "images/storeBackgrounds/DOND.png";
import DONDStoreLogo from "images/storeLogos/DOND-Logo.png";
import DONDCardLogo from "images/gameCards/logo/DOND-Logo.png";
import DONDCardBackground from "images/gameCards/background/dond-logo.jpg";
//import DONDDesktopPreview1 from "images/gameStorePreviews/dond/dond-desktop-1.png";
import DONDTinyCard from "images/tinyCards/dond-tinycard.png";
import DONDMobilePreview1 from "images/gameStorePreviews/dond/dond-mobile-1.jpg";
import DONDMobilePreview2 from "images/gameStorePreviews/dond/dond-mobile-2.jpg";
import DONDDesktopPreview1 from "images/gameStorePreviews/dond/dond-desktop-1.jpg";
import DONDDesktopPreview2 from "images/gameStorePreviews/dond/dond-desktop-2.jpg";


//Pointless
import PointlessLogo from "images/games/pointless-logo.png";
import PointlessStoreBackground from "images/storeBackgrounds/pointless-background.jpg";
import PointlessStoreLogo from "images/storeLogos/pointless-logo.png";
import PointlessCardLogo from "images/gameCards/logo/pointless-logo.png";
import PointlessCardBackground from "images/gameCards/background/pointless-background.jpg";
import PointlessTinyCard from "images/tinyCards/Pointless.jpg";
import PointlessMobilePreview1 from "images/gameStorePreviews/pointless/mobile-1.png";
import PointlessMobilePreview2 from "images/gameStorePreviews/pointless/mobile-2.png";
import PointlessDesktopPreview1 from "images/gameStorePreviews/pointless/desktop-1.png";
import PointlessDesktopPreview2 from "images/gameStorePreviews/pointless/desktop-2.png";


//Tenable
import TenableLogo from "images/games/Tenable-Logo.png";
import TenableCardLogo from "images/gameCards/logo/Tenable-Logo-Small.png";
import TenableCardBackground from "images/gameCards/background/Tenable.jpg";
import TenableStoreBackground from "images/storeBackgrounds/Background-Round-Intro-1.jpg";
import TenableStoreLogo from "images/storeLogos/Tenable-Logo.png";
import TenableMobilePreview1 from "images/gameStorePreviews/mdmd/MDMD-mobile-1.jpg";
import TenableMobilePreview2 from "images/gameStorePreviews/mdmd/MDMD-mobile-2.jpg";
import TenableDesktopPreview1 from "images/gameStorePreviews/mdmd/MDMD-desktop-1.jpg";
import TenableDesktopPreview2 from "images/gameStorePreviews/mdmd/MDMD-desktop-2.jpg";
import TenableTinyCard from "images/tinyCards/MDMD-tinycard.png";

//Doodly
import DoodlyCardLogo from "images/gameCards/logo/Doodly-Logo-Small.png";
import DoodlyCardBackground from "images/gameCards/background/doodly.jpg";
import DoodlyMenuBackground from "images/storeBackgrounds/doodly.jpg";
import DoodlyStoreBackground from "images/storeBackgrounds/Doodly2.jpg";
import DoodlyStoreLogo from "images/storeLogos/doodly.png";
import DoodlyTinyCard from "images/tinyCards/doodly.jpg";

import DoodlyDesktopPreview1 from "images/gameStorePreviews/doodly/Host_preview_1.gif"
import DoodlyDesktopPreview2 from "images/gameStorePreviews/doodly/Host_preview_2.png"
import DoodlyMobilePreview1 from "images/gameStorePreviews/doodly/Client_preview_1.gif"
import DoodlyMobilePreview2 from "images/gameStorePreviews/doodly/Client_preview_2.png"

// Brain Games
import BrainGamesLogo from "images/games/brain-games-logo.png";
import BrainGamesBackground from "images/storeBackgrounds/brain-games-background.png";
import BrainGamesTinyCard from "images/tinyCards/Brain Games.png";



import age6Black from "animations/ageRatings/age-6.png";
import age8Black from "animations/ageRatings/age-8.png";
import age10Black from "animations/ageRatings/age-10.png";
import age12Black from "animations/ageRatings/age-12.png";
import age14Black from "animations/ageRatings/age-14.png";

import age6White from "animations/ageRatings/age-white-6.png";
import age8White from "animations/ageRatings/age-white-8.png";
import age10White from "animations/ageRatings/age-white-10.png";
import age12White from "animations/ageRatings/age-white-12.png";
import age14White from "animations/ageRatings/age-white-14.png";

//import age6Purple from "animations/ageRatings/age-purple-6.png";
//import age8Purple from "animations/ageRatings/age-purple-8.png";
//import age10Purple from "animations/ageRatings/age-purple-10.png";
//import age12Purple from "animations/ageRatings/age-purple-12.png";
//import age14Purple from "animations/ageRatings/age-purple-14.png";

export const BestSellers = [
    "pointless",
    "opc",
    "catchphrase",
    //"donduk",
    //"doodly",
    //"pub_quiz",
    //"mdmd",
    //"universally_challenged",
    //"wwyt",
];

const GameList = [
    {
        type: "Game",
        name: "Tenable",
        pack: 1,
        gameId: "tenable",
        enabled: false,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU, APP_TYPES.SKY],
        logo: TenableLogo,
        description: "Can you find a perfect ten!",
        productId: process.env.REACT_APP_TENABLE_PID,
        price: 12.99,
        gameURL: process.env.REACT_APP_TENABLE_URL,
        storeSlug: '/shop/tenable',
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 10,
            descriptions: [
                {
                    header: "Tenable",
                    body: "Placeholder."
                },
            ],
            lobbyBanner: "",
        },
        addonIds: [],
        gameUpsellIds: ["pointless", "opc", "mdmd"],
        meta: {
            cardLogo: TenableCardLogo,
            cardBackground: TenableCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: TenableStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: TenableStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: TenableMobilePreview1,
                mobile2: TenableMobilePreview2,
                desktop1: TenableDesktopPreview1,
                desktop2: TenableDesktopPreview2,
            },
            tinyCard: TenableTinyCard,
            iconTheme: "light",
            ageRatingIcon: age10White,
        },
        pricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 12.99,
                display: "\u002412.99",
                currency: "\u0024"
            },
            au: {
                raw: 16.99,
                display: "\u002416.99",
                currency: "\u0024"
            }
        }
    },
    //Pointless
    {
        type: "Game",
        name: "Pointless",
        pack: 1,
        gameId: "pointless",
        enabled: true,
        bestSeller: true,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU, APP_TYPES.SKY],
        logo: PointlessLogo,
        description: "Join Xander and Richard in the smash-hit BBC TV show!",
        productId: process.env.REACT_APP_POINTLESS_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_POINTLESS_URL,
        storeSlug: '/shop/pointless',
        iosGameID: 'game.city.pointless',
        androidGameID: 'game.city.pointless',
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 14,
            descriptions: [
                {
                    header: "POINTLESS – OFFICIAL BBC TV SHOW!",
                    body: "The hit TV quiz show is now in your hands. Gather your friends and family and experience the trivia, laughs, and nail-biting fun of the show wherever you are!"
                },
                {
                    header: "FIND THE MOST OBSCURE ANSWERS",
                    body: "Take to the podium in pairs or battle it out alone, testing your knowledge against each other with hundreds of official questions straight from the show!"
                },
                {
                    header: "THE POINTLESS TROPHY",
                    body: "Only the leading team gets a shot at the final round! Answer wisely, aim for the elusive Pointless answers, and claim the iconic trophy as champions of the ultimate quiz showdown."
                }
            ],
            //lobbyBanner: "",
            cornerBanner: {
                text: "NEW",
                colour: "#05B139",
                shopOnly: false
            }
        },
        addonIds: [],
        gameUpsellIds: ["mdmd", "donduk", "catchphrase"],
        meta: {
            cardLogo: PointlessCardLogo,
            cardBackground: PointlessCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: PointlessStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: PointlessStoreLogo,
            bannerColour: '#a700fe',
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: PointlessMobilePreview1,
                mobile2: PointlessMobilePreview2,
                desktop1: PointlessDesktopPreview1,
                desktop2: PointlessDesktopPreview2,
            },
            trailerURL: "https://youtu.be/7L8HyK-ZoF0",
            tinyCard: PointlessTinyCard,
            iconTheme: "light",
            ageRatingIcon: age14White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
    },
    //Doodly
    {
        type: "Game",
        name: "Doodly",
        pack: 1,
        gameId: "doodly",
        enabled: true,
        bestSeller: false,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU, APP_TYPES.SKY],
        logo: MDMDLogo,
        description: "Let's get a doodlin', a drawing game for every mood :)",
        productId: process.env.REACT_APP_DOODLY_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_DOODLY_URL,
        storeSlug: '/shop/doodly',
        partyGame: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 6,
            descriptions: [
                {
                    header: "LET'S GET A DOODLIN'",
                    body: "Who knew chaos could be so artistic? In Doodly, you draw, guess, and create fun moments that rarely make sense. Get your doodlin' fingers ready and dive in."
                },
                {
                    header: "A DRAWING GAME FOR EVERY MOOD",
                    body: "Jump into three crazy game modes, Doodly, Pass The Doodly, and Doodly Movies. Whether you’re racing the clock, or crafting a group animation, every mode brings a fresh twist."
                },
                {
                    header: "GET YOUR DING, DANG DOODLE ON!",
                    body: "From quick rounds to relaxed scribble sessions, Doodly turns every idea into a masterpiece… or a magnificent misunderstanding."
                },
            ],
            lobbyBanner: "",
            cornerBanner: {
                text: "NEW",
                colour: "#05B139",
                shopOnly: false
            }
        },
        addonIds: [],
        gameUpsellIds: ["wwyt", "donduk", "mdmd"],
        meta: {
            cardLogo: DoodlyCardLogo,
            cardBackground: DoodlyCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: DoodlyStoreBackground,
            storeBackgroundColour: '#6d5a9c',
            storeLogo: DoodlyStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#f3921e',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#6d5a9c',
            gameMenuBackground: DoodlyMenuBackground,
            previewImages: {
                mobile1: DoodlyMobilePreview1,
                mobile2: DoodlyMobilePreview2,
                desktop1: DoodlyDesktopPreview1,
                desktop2: DoodlyDesktopPreview2,
            },
            trailerURL: "https://youtu.be/uFcIavFHMNk",
            tinyCard: DoodlyTinyCard,
            iconTheme: "light",
            ageRatingIcon: age6White,
        },
        pricing: {
            gb: {
                raw: 8.99,
                display: "\u00A38.99",
                currency: "\u00A3"
            },
            us: {
                raw: 12.99,
                display: "\u002412.99",
                currency: "\u0024"
            },
            au: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            }
        }
    },
    {
        type: "Game",
        name: "The 1% Club",
        pack: 1,
        gameId: "opc",
        enabled: true,
        bestSeller: true,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU, APP_TYPES.SKY],
        logo: OPCLogo,
        description: "Are you the smartest person in the room? Time to find out!",
        licence: "THE 1% CLUB™ and THE 1% CLUB logo™ & © Magnum Media Limited 2022. Licensed by BBC Studios.",
        productId: process.env.REACT_APP_OPC_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_OPC_URL,
        storeSlug: '/shop/one-percent-club',
        iosGameID: 'game.city.1pclub',
        androidGameID: 'game.city.1pclub',
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "The Global Phenomenon has landed!",
                    body: "If you're no good at trivia, don't worry! The 1% Club is all about common sense and how your brain actually works."
                },
                {
                    header: "Are you in the 1%?",
                    body: "Have you ever wondered if you're the smartest person in the room? Time to test that theory in our latest party game."
                },
                {
                    header: "So, you think you're smart?",
                    body: "Join the club... The 1% Club in the official game of the Global phenomenon that's fun for the whole family."
                },
            ],
            lobbyBanner: "",
            cornerBanner: {
                text: "NEW",
                colour: "#05B139",
                shopOnly: false
            }
        },
        addonIds: [],
        gameUpsellIds: ["mdmd", "donduk", "catchphrase"],
        meta: {
            cardLogo: OPCCardLogo,
            cardBackground: OPCCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: OPCStoreBackground,
            storeBackgroundColour: '#FF0000', //#04FF79
            storeLogo: OPCStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#000066', //opc tomato as per style guide
            gameMenuTextColour: '#FFFFFF',
            gameMenuBackgroundColour: "#000066",
            previewImages: {
                mobile1: OPCMobilePreview1,
                mobile2: OPCMobilePreview2,
                desktop1: OPCDesktopPreview1,
                desktop2: OPCDesktopPreview2,
            },
            trailerURL: "https://youtu.be/EXiCHzDFV2g",
            tinyCard: OPCTinyCard,
            iconTheme: "light",
            ageRatingIcon: age8White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        }
    },
    { // IPT
        type: "Game",
        name: "I Put That",
        pack: 1,
        gameId: "wwyt",
        enabled: true,
        bestSeller: false,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU],
        logo: IPTLogo,
        description: "Match the thinker fast. More overlaps, more points, more laughs.",
        productId: process.env.REACT_APP_IPT_PID,
        price: 8.99,
        gameURL: process.env.REACT_APP_IPT_URL,
        storeSlug: '/shop/i-put-that',
        iosGameID: 'game.city.ipt',
        androidGameID: 'game.city.ipt',
        partyGame: true,
        gameInfo: {
            minPlayers: 3,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "Great minds think alike",
                    body: "Match wits with friends as you guess what the thinker was thinking. The more your answers match, the higher you score!"
                },
                {
                    header: "I PUT THAT! Did you?",
                    body: "Race the clock to fill in as many answers as you can before the time runs out. Bonus points for cracking everyone up!"
                },
                {
                    header: "Mind Games and Mayhem",
                    body: "See if your friends can read your mind… or just make them laugh trying."
                },
            ],
            //lobbyBanner: "BETA",
            //cornerBanner: {
            //    text: "NEW",
            //    colour: "#05B139",
            //    shopOnly: false
            //}
        },
        addonIds: [],
        gameUpsellIds: ["universally_challenged", "pub_quiz", "catchphrase"],
        meta: {
            cardLogo: IPTLogo,
            cardBackground: IPTBackground,
            cardPriceColour: '#10232B',
            storeBackground: IPTStoreBackground,
            storeBackgroundColour: '#1e96cb',
            storeLogo: IPTStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#1e96cb',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#1e96cb',
            previewImages: {
                mobile1: IPTMobilePreview1,
                mobile2: IPTMobilePreview2,
                desktop1: IPTDesktopPreview1,
                desktop2: IPTDesktopPreview2,
            },
            trailerURL: "https://youtu.be/Ts06gQcrshQ",
            tinyCard: IPTTinyCard,
            ageRatingIcon: age8Black,
        },
        pricing: {
            gb: {
                raw: 8.99,
                display: "\u00A38.99",
                currency: "\u00A3"
            },
            us: {
                raw: 12.99,
                display: "\u002412.99",
                currency: "\u0024"
            },
            au: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            }
        }
    },
    //MDMD
    {
        type: "Game",
        name: "Million Dollar Money Drop",
        pack: 1,
        gameId: "mdmd",
        enabled: true,
        bestSeller: false,
        showInHero: true,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU, APP_TYPES.SKY],
        logo: MDMDLogo,
        description: "Test your nerve in this thrilling party game of the iconic TV show!",
        productId: process.env.REACT_APP_MDMD_PID,
        price: 14.99,
        gameURL: process.env.REACT_APP_MDMD_URL,
        storeSlug: '/shop/million-dollar-money-drop',
        iosGameID: 'game.city.mdmd',
        androidGameID: 'game.city.mdmd',
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            maxPlayers: 8,
            avgRoundLengthText: '20 mins',
            minAge: 10,
            descriptions: [
                {
                    header: "STEP UP AND SEE WHAT DROPS",
                    body: "In this officially licensed party game version of The Million Dollar Money Drop you can step up and face the drop!"
                },
                {
                    header: "EYES ON THE PRIZE",
                    body: "Up to 8 players can tackle tricky questions and make risky moves to keep their million from falling through the trapdoor!"
                },
                {
                    header: "WHO WILL HOLD ON?",
                    body: "Take the plunge! Bring the high-stakes excitement home with just a screen, your phone, and the courage to play."
                },
            ],
            //lobbyBanner: "BETA",
            //cornerBanner: {
            //    text: "NEW",
            //    colour: "#05B139",
            //    shopOnly: false
            //}
        },
        addonIds: [],
        gameUpsellIds: ["catchphrase", "donduk", "opc"],
        meta: {
            cardLogo: MDMDCardLogo,
            cardBackground: MDMDCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: MDMDStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: MDMDStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: MDMDMobilePreview1,
                mobile2: MDMDMobilePreview2,
                desktop1: MDMDDesktopPreview1,
                desktop2: MDMDDesktopPreview2,
            },
            trailerURL: "https://youtu.be/Q7Q-na0HhVQ",
            tinyCard: MDMDTinyCard,
            iconTheme: "light",
            ageRatingIcon: age10White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        }
    },
    //Catchphrase
    {
        type: "Game",
        name: "Catchphrase",
        pack: null,
        gameId: "catchphrase",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: true,
        showInHero: true,
        logo: CatchphraseLogo,
        description: "Guessing well-known phrases or sayings from animated puzzles.",
        licence: "Catchphrase was created by Pasetta Productions Inc and Steven Radosh. Licensed by All3Media International Limited. Catch Phrase Logo, Imagery and Mr Chips character © 2024 All3Media International Limited and STV Productions Limited.",
        productId: process.env.REACT_APP_CATCHPHRASE_PID,
        price: 9.99,
        bestSeller: true,
        gameURL: process.env.REACT_APP_CATCHPHRASE_URL,
        storeSlug: '/shop/catchphrase',
        iosGameID: 'game.city.catchphrase',
        androidGameID: 'game.city.catchphrase',
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLength: 600,
            avgRoundLengthText: '20 Mins',
            minAge: 8,
            descriptions: [
                {
                    header: "JUST LIKE THE GAMESHOW! ",
                    body: "The much-loved classic game show, is now in the palm of your hand! Relive the fun of the iconic favorite with friends and family."
                },
                {
                    header: "SAY WHAT YOU SEE",
                    body: "The aim of the game is to identify familiar catchphrases. Remember to say what you see as you play hundreds of official catchphrases straight from the show."
                },
                {
                    header: "ITS TIME TO TAKE ON MR. CHIPS",
                    body: "Mr Chips will be there along the way to act out the catchphrases. So, when you're ready, buzz in and show your Catch Phrase knowledge!"
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["mdmd", "opc", "donduk"],
        meta: {
            cardLogo: CatchphraseLogo,
            cardBackground: CatchphraseCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: CatchphraseBackground,
            storeLogo: CatchphraseLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#1e236e',
            gameMenuTextColour: '#FFFFFF',
            gameMenuBackgroundColour: '#2c34a0',
            previewImages: {
                mobile1: CatchphraseMobilePreview1,
                mobile2: CatchphraseMobilePreview2,
                desktop1: CatchphraseDesktopPreview1,
                desktop2: CatchphraseDesktopPreview2,
            },
            trailerURL: "https://youtu.be/IyMurUSsLh4",
            tinyCard: CatchphraseTinyCard,
            iconTheme: "light",
            ageRatingIcon: age8White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 14.99,
                display: "\u00A314.99",
                currency: "\u00A3"
            },
            us: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            },
            au: {
                raw: 29.99,
                display: "\u002429.99",
                currency: "\u0024"
            }
        }
    },
    //Deal or no Deal UK
    {
        type: "Game",
        name: "Deal or no Deal",
        pack: 1,
        gameId: "donduk",
        enabled: true,
        showInHero: true,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.ROKU, APP_TYPES.SKY],
        logo: DONDLogo,
        description: "The legendary TV game show reimagined as a party game!",
        productId: process.env.REACT_APP_DONDUK_PID,
        price: 14.99,
        bestSeller: false,
        gameURL: process.env.REACT_APP_DONDUK_URL,
        storeSlug: '/shop/deal-or-no-deal-uk',
        iosGameID: 'game.city.dond',
        androidGameID: 'game.city.dond',
        //kickstarter: true,
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "THE BANKER IS BACK!",
                    body: "In this officially licensed party game version of Deal or No Deal, you take the hot seat—right in your living room."
                },
                {
                    header: "THE REAL DEAL!",
                    body: "Up to 8 players can compete to outwit the Banker, and prove who knows how to strike a deal."
                },
                {
                    header: "JUST ONE QUESTION?",
                    body: "Deal or No Deal? Bring the game show home with just a screen, your phone, and the nerve to play."
                }
            ],
            lobbyBanner: "",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["universally_challenged", "poker", "catchphrase"],
        meta: {
            cardLogo: DONDCardLogo,
            cardBackground: DONDCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: DONDStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: DONDStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: DONDMobilePreview1,
                mobile2: DONDMobilePreview2,
                desktop1: DONDDesktopPreview1,
                desktop2: DONDDesktopPreview2,
            },
            trailerURL: "https://youtu.be/Cy_k2dRz9Nc",
            tinyCard: DONDTinyCard,
            iconTheme: "light",
            ageRatingIcon: age8White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 14.99,
                display: "\u00A314.99",
                currency: "\u00A3"
            },
            us: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            },
            au: {
                raw: 29.99,
                display: "\u002429.99",
                currency: "\u0024"
            }
        }
    },
    //Deal or no Deal (Legacy)
    {
        type: "Game",
        name: "Deal or no Deal",
        pack: 1,
        gameId: "dond",
        enabled: false,
        showInHero: false,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY],
        logo: DONDLogo,
        description: "The legendary TV game show reimagined as a party game!",
        productId: process.env.REACT_APP_DOND_PID,
        price: 14.99,
        bestSeller: false,
        gameURL: process.env.REACT_APP_DOND_URL,
        storeSlug: '/shop/deal-or-no-deal',
        iosGameID: 'game.city.dond',
        androidGameID: 'game.city.dond',
        //kickstarter: true,
        gameShow: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "THE BANKER IS BACK!",
                    body: "In this officially licensed party game version of Deal or No Deal, you take the hot seat—right in your living room."
                },
                {
                    header: "THE REAL DEAL!",
                    body: "Up to 8 players can compete to outwit the Banker, and prove who knows how to strike a deal."
                },
                {
                    header: "JUST ONE QUESTION?",
                    body: "Deal or No Deal? Bring the game show home with just a screen, your phone, and the nerve to play."
                }
            ],
            lobbyBanner: "",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["mdmd", "opc", "catchphrase"],
        meta: {
            cardLogo: DONDCardLogo,
            cardBackground: DONDCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: DONDStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: DONDStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: DONDMobilePreview1,
                mobile2: DONDMobilePreview2,
                desktop1: DONDDesktopPreview1,
                desktop2: DONDDesktopPreview2,
            },
            tinyCard: DONDTinyCard,
            iconTheme: "light",
            ageRatingIcon: age8White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        }
    },


    //Pool hall
    {
        type: "Game",
        name: "Pool Hall",
        pack: null,
        gameId: "pool",
        enabled: false,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY],
        logo: PoolLogo,
        description: "Bring pool home anytime, anywhere with three fun modes to play",
        productId: process.env.REACT_APP_POOL_PID,
        price: 9.99,
        bestSeller: false,
        gameURL: process.env.REACT_APP_POOL_URL,
        storeSlug: '/shop/pool',
        gameInfo: {
            minPlayers: 1,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "BE THE 8 BALL BOSS",
                    body: "Classic 2-player pool with all the rules you know and love. Pot your colour, avoid fouls, and finally sink the black to win."
                },
                {
                    header: "CLEAR UP",
                    body: "Go solo and race against the clock to pot all the balls as fast as you can. No fouls, just speed and skill. Perfect for quick-fire practice."
                },
                {
                    header: "BE THE 8 BALL BOSS",
                    body: "Jump in with up to 10 players, 3 lives each, one winner. Miss a shot, lose a life. It's fast, fierce, and perfect for party play."
                },
            ],
            //banner: "Free Junior Mode Update!",
        },
        addonIds: [],
        gameUpsellIds: ["opc", "catchphrase", "pointless"],
        meta: {
            cardLogo: PoolShopLogo,
            //cardLogo2: ColourBrainCardLogoJunior,
            cardBackground: PoolHallCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: PoolHallCardBackground,
            storeBackgroundColour: '#222b39',
            storeLogo: PoolLogo,
            //storeLogo2: ColourBrainCardLogoJunior,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#0bdbfe',
            gameMenuTextColour: '#FFFFFF',
            gameMenuBackgroundColour: '#222b39',
            previewImages: {
                singleImage: PoolStorePagePreview,
                desktop1: PoolGameplayPreview,
            },
            tinyCard: PoolLogo,
            singleImage: true,
            iconTheme: "light",
            ageRatingIcon: age8White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
    },
    //Playing with fire
    {
        type: "Game",
        name: "Playing With Fire",
        pack: null,
        gameId: "playing_with_fire",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY],
        enabled: true,
        showInHero: false,
        logo: PWFLogo,
        description: <>Classic arcade action meets<br />modern party fun.</>,
        productId: process.env.REACT_APP_PWF_PID,
        price: 9.99,
        bestSeller: false,
        gameURL: process.env.REACT_APP_PWF_URL,
        storeSlug: '/shop/playing-with-fire',
        iosGameID: 'game.city.pwf',
        androidGameID: 'game.city.pwf',
        gameInfo: {
            minPlayers: 1,
            maxPlayers: 4,
            avgRoundLengthText: '20 mins',
            minAge: 6,
            descriptions: [
                {
                    header: "EXPLOSIVE MULTIPLAYER MAYHEM",
                    body: "Drop bombs, dodge fire, and outsmart your friends in the explosive multiplayer chaos of Playing with Fire!"
                },
                {
                    header: "INSTANT ARCADE FUN",
                    body: "Classic arcade action meets modern party fun—no downloads, just pure fiery competition online!"
                },
                {
                    header: "CLASSIC CHAOS, MODERN TWIST",
                    body: "Light the fuse and battle it out live—it's Bomberman-style mayhem, right in your browser!"
                }
            ],
            //banner: "Free Junior Mode Update!",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["opc", "catchphrase", "pointless"],
        meta: {
            cardLogo: pwfShineLogo,
            //cardLogo2: ColourBrainCardLogoJunior,
            cardBackground: PWFbackground,
            cardPriceColour: '#10232B',
            storeBackground: pwfBackground2,
            storeBackgroundColour: '#FFFFFF',
            storeLogo: PWFLogoLarge,
            //storeLogo2: ColourBrainCardLogoJunior,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#020222',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#ffffff',
            singleImage: true,
            previewImages: {
                singleImage: PWFGame2,
                desktop1: PWFGame2,
            },
            tinyCard: PWFTinyCard,
            trailerURL: "https://youtu.be/2qsnSV1RbQA",
            infoBackgroundImage: PWFMetal,
            infoBackgroundImagePixelated: true,
            animatedLogo: pwfShineLogo,
            animatedAccent: BombAnimationOnLoop,
            iconTheme: "dark",
            ageRatingIcon: age6Black,
        },
        pricing: {
            gb: {
                raw: 6.99,
                display: "\u00A36.99",
                currency: "\u00A3"
            },
            us: {
                raw: 9.99,
                display: "\u00249.99",
                currency: "\u0024"
            },
            au: {
                raw: 14.99,
                display: "\u002414.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 7.99,
                display: "\u00A37.99",
                currency: "\u00A3"
            },
            us: {
                raw: 10.99,
                display: "\u002410.99",
                currency: "\u0024"
            },
            au: {
                raw: 16.99,
                display: "\u002416.99",
                currency: "\u0024"
            }
        }
    },
    //Universally challenged
    {
        type: "Game",
        name: "Universally Challenged",
        pack: null,
        gameId: "universally_challenged",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: true,
        showInHero: true,
        logo: UCLogo,
        description: "An out of this world quiz that brings AI to your game nights!",
        productId: process.env.REACT_APP_UC_PID,
        price: 12.99,
        bestSeller: false,
        gameURL: process.env.REACT_APP_UC_URL,
        storeSlug: '/shop/universally-challenged',
        iosGameID: 'game.city.uc',
        androidGameID: 'game.city.uc',
        partyGame: true,
        gameInfo: {
            minPlayers: 2,
            avgRoundLengthText: '20 mins',
            minAge: 12,
            descriptions: [
                {
                    header: "AI MAKES YOU THE STAR!",
                    body: "Say cheese! Just take a photo of yourself, and our AI will transform you into a completely random art style."
                },
                {
                    header: "FIVE GAMES, INFINITE LAUGHS!",
                    body: "From general knowledge and geography to spelling and film, our five unique games will put your whole families brain to the test!"
                },
                {
                    header: "FAME HAS NEVER LOOKED SO FUNNY!",
                    body: "In the final round, your face gets mashed up with a random celebrity. Can you see past the A-list disguise?"
                }
            ],
            //banner: "Free Junior Mode Update!",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["opc", "catchphrase", "pointless"],
        meta: {
            cardLogo: UCCardLogo,
            //cardLogo2: ColourBrainCardLogoJunior,
            cardBackground: UCCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: UCStoreBackground,
            storeBackgroundColour: '#FFFFFF',
            storeLogo: UCLogo,
            //storeLogo2: ColourBrainCardLogoJunior,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#d1532c',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#ffffff',
            previewImages: {
                mobile1: UCMobilePreview1,
                mobile2: UCMobilePreview2,
                desktop1: UCDesktopPreview1,
                desktop2: UCDesktopPreview2,
            },
            trailerURL: "https://youtu.be/uwK7bp9qOOI",
            tinyCard: UCTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age12Black,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },

    //Poker night
    {
        type: "Game",
        name: "Poker Night",
        pack: 1,
        gameId: "poker",
        enabled: true,
        showInHero: false,
        bestSeller: false,
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY],
        logo: PokerNightLogo,
        description: "Raise the stakes from the sofa. No chips, no table, just pure poker.",
        productId: process.env.REACT_APP_POKER_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_POKER_URL,
        storeSlug: '/shop/poker',
        iosGameID: 'game.city.poker',
        androidGameID: 'game.city.poker',
        gameInfo: {
            minPlayers: 2,
            avgRoundLengthText: '20 mins',
            minAge: 14,
            descriptions: [
                {
                    header: "THE ULTIMATE BLUFF FEST",
                    body: "Bluff, bet, and go all-in with up to 8 friends in the ultimate party poker experience—no cards required, just your phone!"
                },
                {
                    header: "YOUR PHONE HOLDS THE CARDS",
                    body: "Your hand stays secret on your phone—raise, call, fold, or go all-in with just a tap whilst playing from your couch or across the globe!"
                },
                {
                    header: "RAISE THE STAKES",
                    body: "Classic rules, slick design, and zero setup. Whether you're a card shark or just in for a laugh, this is poker made to be played anywhere!"
                },
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["pub_quiz", "catchphrase", "playing_with_fire"],
        meta: {
            cardLogo: PokerNightCardLogo,
            cardBackground: PokerNightCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: PokerNightStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: PokerNightLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: PokerNightMobilePreview1,
                mobile2: PokerNightMobilePreview2,
                desktop1: PokerNightDesktopPreview1,
                desktop2: PokerNightDesktopPreview2,
            },
            trailerURL:"https://youtu.be/yYhBMWImUjw",
            tinyCard: PokerNightTinyCard,
            iconTheme: "light",
            ageRatingIcon: age14White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },

    //Pub quiz
    {
        type: "Game",
        name: "Pub Quiz",
        pack: null,
        gameId: "pub_quiz",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: true,
        showInHero: false,
        bestSeller: false,
        logo: PubQuizLogo,
        price: 9.99,
        description: "Race to the Bar in this fast-paced Pub Quiz!",
        productId: process.env.REACT_APP_PQ_PID,
        gameURL: process.env.REACT_APP_PUBQUIZ_URL,
        storeSlug: '/shop/pub-quiz',
        iosGameID: 'game.city.pub',
        androidGameID: 'game.city.pub',
        partyGame: true,
        gameInfo: {
            minPlayers: 2,
            avgRoundLength: 1800,
            avgRoundLengthText: '30 mins',
            minAge: 12,
            descriptions: [
                {
                    header: "CLASSIC PUB QUIZ",
                    body: "Grab your drink, answer questions, and Race to the Bar! Outsmart and outpace to celebrate victory in this fun trivia game."
                },
                {
                    header: "THREE QUIZ ROUNDS",
                    body: "Pick your categories, outwit opponents in three quiz rounds. Bonus chips spice up your strategy."
                },
                {
                    header: "RACE TO THE BAR",
                    body: "Select as many correct answers as you dare, but don't get one wrong! Make it to the bar before the landlord calls time!"
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["catchphrase", "opc", "pointless"],
        meta: {
            cardLogo: PubQuizCardLogo,
            cardBackground: PubQuizCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: PubQuizStoreBackground,
            storeBackgroundColour: '#977069',
            storeLogo: PubQuizStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#545D6E',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#69B8B9',
            previewImages: {
                mobile1: PubQuizMobilePreview1,
                mobile2: PubQuizMobilePreview2,
                desktop1: PubQuizDesktopPreview1,
                desktop2: PubQuizDesktopPreview2,
            },
            tinyCard: PubQuizTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age12Black,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },
    //Pub quiz
    {
        type: "Game",
        name: "Brain Games",
        pack: null,
        gameId: "brain_games",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: true,
        showInHero: false,
        bestSeller: false,
        isPack: true,
        subGames: ["anagram_magic", "maths_master", "word_wheel"],
        logo: BrainGamesLogo,
        price: 8.99,
        description: "Get access to the Brain Games Collection!",
        productId: process.env.REACT_APP_BRAINGAMES_PID,
        gameURL: process.env.REACT_APP_BRAINGAMES_URL,
        storeSlug: '/shop/brain-games',
        //iosGameID: 'game.city.pub',
        //androidGameID: 'game.city.pub',
        partyGame: true,
        gameInfo: {
            minPlayers: 1,
            avgRoundLength: 1200,
            avgRoundLengthText: '20+ mins',
            minAge: 8,
            descriptions: [
                {
                    header: "ANAGRAM MAGIC", 
                    body: "Find the longest words and impress your friends with your immense vocabulary."
                },
                {
                    header: "MATHS MASTER",
                    body: "Have you've got what it takes to be a Maths Master? Sharpen your pencils and your wits."
                },
                {
                    header: "WORD WHEEL",
                    body: "Test your word prowess and craft words that revolve around the central letter and showcase your linguistic finesse."
                }
            ],
            //cornerBanner: {
            //    text: "SALE",
            //    colour: "#E63946",
            //    shopOnly: true
            //}
        },
        addonIds: [],
        gameUpsellIds: ["pointless", "catchphrase", "opc"],
        meta: {
            cardLogo: BrainGamesLogo,
            cardBackground: BrainGamesBackground,
            cardPriceColour: '#10232B',
            storeBackground: BrainGamesBackground,
            storeBackgroundColour: '#977069',
            storeLogo: BrainGamesLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#69B8B9',
            previewImages: {
                mobile1: MathsMasterMobilePreview1,
                mobile2: WordWheelMobilePreview1,
                desktop1: AnagramMagicDesktopPreview1,
                desktop2: MathsMasterDesktopPreview1,
            },
            tinyCard: BrainGamesTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age8Black,
        },
        pricing: {
            gb: {
                raw: 8.99,
                display: "\u00A38.99",
                currency: "\u00A3"
            },
            us: {
                raw: 12.99,
                display: "\u002412.99",
                currency: "\u0024"
            },
            au: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            }
        },
        //oldPricing: {
        //    gb: {
        //        raw: 8.99,
        //        display: "\u00A38.99",
        //        currency: "\u00A3"
        //    },
        //    us: {
        //        raw: 12.99,
        //        display: "\u002412.99",
        //        currency: "\u0024"
        //    },
        //    au: {
        //        raw: 17.99,
        //        display: "\u002417.99",
        //        currency: "\u0024"
        //    }
        //}
    },

    //Herd mentality
    {
        type: "Game",
        name: "Herd Mentality",
        pack: 1,
        gameId: "herd_mentality",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        bestSeller: false,
        logo: HerdLogo,
        description: "One black and white mission: \ndon't be the odd one out!",
        productId: process.env.REACT_APP_HERD_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_HERD_URL,
        storeSlug: '/shop/herd-mentality',
        iosGameID: 'game.city.herd',
        androidGameID: 'game.city.herd',
        partyGame: false,
        gameInfo: {
            minPlayers: 3,
            avgRoundLength: 1800,
            avgRoundLengthText: '20 mins',
            minAge: 12,
            banner: "NEW ADD-ON AVAILABLE!",
            descriptions: [
                {
                    header: "DON'T HAVE A COW MAN!",
                    body: "In Herd Mentality, if your answer is the odd one out, you'll be saddled with the Pink Cow - and you don't want that."
                },
                {
                    header: "NAME A FOOD WITH A HOLE IN IT...",
                    body: "Do you think your answer would match everyone else's?"
                },
                {
                    header: "\"THE BEST PARTY GAME EVER CREATED\"",
                    body: "\"Herd Mentality is guaranteed to have you in stitches... a fabulous game to play with families\" - TechRadar 2022"
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: ["moosic_moovies"],
        gameUpsellIds: ["can_of_squirms", "colour_brain", "scrawl"],
        meta: {
            cardLogo: HerdCardLogo,
            cardBackground: HerdCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: HerdStoreBackground,
            storeBackgroundColour: '#FFFFFF',
            storeInfoBackground: '#FFFFFF',
            storeLogo: HerdStoreLogo,
            storeAccentColour: '#000000',
            bannerColour: '#E56DA6',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#ffffff',
            previewImages: {
                mobile1: HerdMobilePreview1,
                mobile2: HerdMobilePreview2,
                desktop1: HerdDesktopPreview1,
                desktop2: HerdDesktopPreview2,
            },
            tinyCard: HerdTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age12Black,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            },
        }
    },
    //Scrawl
    {
        type: "Game",
        name: "Scrawl",
        pack: 1,
        gameId: "scrawl",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        bestSeller: false,
        logo: ScrawlLogo,
        description: "A drawing game that can go very\n wrong, very quickly...",
        productId: process.env.REACT_APP_SCRAWL_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_SCRAWL_URL,
        storeSlug: '/shop/scrawl',
        iosGameID: 'game.city.scrawl',
        androidGameID: 'game.city.scrawl',
        partyGame: false,
        gameInfo: {
            minPlayers: 3,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "BAD DRAWERS WELCOME",
                    body: "You don't have to be good at drawing to play Scrawl. In fact, the worse you are, the better."
                },
                {
                    header: "SCRAWL STARTS WITH A SILLY PHRASE",
                    body: "You have to draw ludicrous things like, \"A Monkey Knife Fight\" or \"A Haunted Oven\", then pass it on."
                },
                {
                    header: "PASS IT ON",
                    body: "By the time your rubbish drawing gets back to you things will have gone very wrong. Unveil the whole crazy story, funniest scrawler wins."
                },
                //{
                //    header: "WARPED MINDS WELCOME",
                //    body: "We've heard what some of you have been doing on Scrawl, and we thought sure. Why not? For those with less innocent minds, an optional 17+ game mode is now available!"
                //}
            ],
            //banner: "100 New Scrawls!",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: ["scrawl_adult"],
        gameUpsellIds: ["can_of_squirms", "draw_with", "pointless"],
        meta: {
            cardLogo: ScrawlCardLogo,
            cardBackground: ScrawlCardBackground,
            cardPriceColour: '#EC0080',
            storeBackground: ScrawlStoreBackground,
            storeBackgroundColour: '#FFD900',
            storeInfoBackground: '#FFFFFF',
            storeLogo: ScrawlStoreLogo,
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#EA085E',
            previewImages: {
                mobile1: ScrawlMobilePreview1,
                mobile2: ScrawlMobilePreview2,
                desktop1: ScrawlDesktopPreview1,
                desktop2: ScrawlDesktopPreview2,
            },
            tinyCard: ScrawlTinyCard,
            iconTheme: "light",
            ageRatingIcon: age8White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: '\u00A312.99',
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },
    //YCSU
    {
        type: "Game",
        name: `You Cant Say "Umm"`,
        pack: 2,
        gameId: "cant_say_umm",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        showInHero: false,

        logo: YCSULogo,
        description: "Describe weird things in this party game without... umm... hesitating.",
        productId: process.env.REACT_APP_YCSU_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_YCSU_URL,
        storeSlug: '/shop/you-cant-say-umm',
        iosGameID: 'game.city.ycsu',
        androidGameID: 'game.city.ycsu',
        partyGame: false,
        gameInfo: {
            minPlayers: 4,
            avgRoundLengthText: '20 mins',
            minAge: 12,
            descriptions: [
                {
                    header: "UMM!",
                    body: "Describe ridiculous word combos for your team to guess before the time runs out... but don't forget, you can't say umm!"
                },
                {
                    header: "ALWAYS MIXING THINGS UP",
                    body: `You're not just avoiding "umm"... this is a game for adults and families that has loads of new challenges, like 'change seats for every right answer' and 'do everything in a high-pitched voice'.`
                },
                {
                    header: "MADE FOR GAME NIGHT",
                    body: "Ding ding ding! The noisy bell, group celebrations and tongue-tied slip ups make this a hilarious party game for both families and adults on game night."
                }
            ],
            //banner: "BETA",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["scrawl", "chameleon", "herd_mentality"],
        meta: {
            cardLogo: YCSUCardLogo,
            //cardLogo2: ColourBrainCardLogoJunior,
            cardBackground: YCSUCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: YCSUStoreBackground,
            storeBackgroundColour: '#FFFFFF',
            storeLogo: YCSUStoreLogo,
            //storeLogo2: ColourBrainCardLogoJunior,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#3B4046',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#ffffff',
            previewImages: {
                mobile1: YCSUMobilePreview1,
                mobile2: YCSUMobilePreview2,
                desktop1: YCSUDesktopPreview1,
                desktop2: YCSUDesktopPreview2,
            },
            tinyCard: YCSUTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age12Black,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },
    //Chameleon
    {
        type: "Game",
        name: "Chameleon",
        pack: 2,
        gameId: "chameleon",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        logo: ChameleonLogo,
        description: "Pick a secret word, then try to\n catch out the guilty player!",
        productId: process.env.REACT_APP_CHAMELEON_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_CHAMELEON_URL,
        storeSlug: '/shop/the-chameleon',
        iosGameID: 'game.city.chameleon',
        androidGameID: 'game.city.chameleon',
        partyGame: false,
        gameInfo: {
            minPlayers: 3,
            avgRoundLengthText: '20 mins',
            minAge: 14,
            descriptions: [
                {
                    header: "One Of You Is The Chameleon",
                    body: "In this party game, your job is to blend in and not get caught."
                },
                {
                    header: "Catch That Chameleon!",
                    body: "Everyone else it trying to work out who the Chameleon is. Everyone suspects everyone else at the beginning."
                },
                {
                    header: "One Word Can Give You Away",
                    body: "Using one carefully chosen word based on a secret topic, you each try to smoke out the Chameleon, who doesn't know what the secret topic is."
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["colour_brain", "draw_with", "can_of_squirms"],
        meta: {
            cardLogo: ChameleonCardLogo,
            cardBackground: ChameleonCardBackground,
            cardPriceColour: '#007DA5',
            storeBackground: ChameleonStoreBackground,
            storeBackgroundColour: '#000000',
            storeLogo: ChameleonStoreLogo,
            storeInfoBackground: '#EBEF66',
            storeAccentColour: '#029480',
            gameMenuTextColour: '#FFFFFF',
            gameMenuBackgroundColour: '#000000',
            previewImages: {
                mobile1: ChameleonMobilePreview1,
                mobile2: ChameleonMobilePreview2,
                desktop1: ChameleonDesktopPreview1,
                desktop2: ChameleonDesktopPreview2,
            },
            tinyCard: ChameleonTinyCard,
            iconTheme: "light",
            ageRatingIcon: age14White,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },
    //Clour brain
    {
        type: "Game",
        name: "Colour Brain",
        pack: 2,
        gameId: "colour_brain",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        logo: ColourBrainLogo,
        description: "A party trivia game where\n every answer is a colour!",
        productId: process.env.REACT_APP_CB_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_COLOURBRAIN_URL,
        storeSlug: '/shop/colour-brain',
        iosGameID: 'game.city.colourbrain',
        androidGameID: 'game.city.colourbrain',
        gameInfo: {
            minPlayers: 2,
            avgRoundLengthText: '20 mins',
            minAge: 12,
            descriptions: [
                {
                    header: "YOU START WITH THE ANSWERS",
                    body: "All the answers you need in Colourbrain are in your hand. And they're all colours!"
                },
                {
                    header: "300 COLOURFUL QUESTIONS",
                    body: "What colour is the lid on full-fat milk... what colour is a sharon fruit... which colour cards would you put down?"
                },
                {
                    header: "QUICK TO LEARN, EASY TO PLAY",
                    body: "Everyone in the family can get involved with Colourbrain. Pick up how to play in minutes."
                },
                {
                    header: "JUNIOR COLOUR BRAIN (INCLUDED)",
                    body: "Keeping the same fun trivia and exciting gameplay, with over 100 family-friendly questions, this new edition is not only fun but also educational, helping kids learn colors and boosting their memory skills."
                }
            ],
            //banner: "Free Junior Mode Update!",
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: ["colour_brain_junior"],
        gameUpsellIds: ["chameleon", "draw_with", "herd_mentality"],
        meta: {
            cardLogo: ColourBrainCardLogo,
            //cardLogo2: ColourBrainCardLogoJunior,
            cardBackground: ColourBrainCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: ColourBrainStoreBackground,
            storeBackgroundColour: '#FFFFFF',
            storeLogo: ColourBrainStoreLogo,
            //storeLogo2: ColourBrainCardLogoJunior,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#93A2AA',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#ffffff',
            previewImages: {
                mobile1: ColourBrainMobilePreview1,
                mobile2: ColourBrainMobilePreview2,
                desktop1: ColourBrainDesktopPreview1,
                desktop2: ColourBrainDesktopPreview2,
            },
            tinyCard: ColourBrainTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age12Black,
        },
        pricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.5,
                display: "\u002414.50",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 12.99,
                display: "\u00A312.99",
                currency: "\u00A3"
            },
            us: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            },
            au: {
                raw: 27.99,
                display: "\u002427.99",
                currency: "\u0024"
            }
        }
    },
    //Draw with dave
    {
        type: "Game",
        name: "Draw along with Dave",
        pack: 2,
        gameId: "draw_with",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        logo: DrawWithLogo,
        description: "Pick up your paintbrush and\n create your masterpiece!",
        productId: process.env.REACT_APP_DRAWWITHDAVE_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_DRAWWITH_URL,
        storeSlug: '/shop/draw-along-with-dave',
        iosGameID: 'game.city.dave',
        androidGameID: 'game.city.dave',
        gameInfo: {
            minPlayers: 2,
            avgRoundLengthText: '30 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "UNLEASH YOUR INNER ARTIST",
                    body: "Take turns playing as Dave, creating your masterpiece and describing as you go."
                },
                {
                    header: "FOLLOW ALONG... IF YOU CAN",
                    body: "Everyone else, it's your job to listen to Dave's instructions, draw along with them, and try to guess what it's supposed to be!"
                },
                {
                    header: "ANYONE CAN DO IT",
                    body: "If you're a good artist, that's great. If you're a bad artist, that's even better."
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["colour_brain", "chameleon", "scrawl"],
        meta: {
            cardBackground: DrawWithCardBackground,
            cardLogo: DrawWithCardLogo,
            cardPriceColour: '#FF5F6B',
            storeBackground: DrawWithStoreBackground,
            storeBackgroundColour: '#093883',
            storeLogo: DrawWithStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#000000',
            gameMenuTextColour: '#000000',
            gameMenuBackgroundColour: '#FECD57',
            previewImages: {
                mobile1: DrawWithMobilePreview1,
                mobile2: DrawWithMobilePreview2,
                desktop1: DrawWithDesktopPreview1,
                desktop2: DrawWithDesktopPreview2,
            },
            tinyCard: DaveTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age8Black,
        },
        pricing: {
            gb: {
                raw: 8.99,
                display: "\u00A38.99",
                currency: "\u00A3"
            },
            us: {
                raw: 12.99,
                display: "\u002412.99",
                currency: "\u0024"
            },
            au: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.99,
                display: "\u002414.99",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        }
    },
    //Anagram magic
    {
        type: "Game",
        name: "Anagram Magic",
        pack: 2,
        gameId: "anagram_magic",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        bestSeller: false,
        logo: AnagramMagicLogo,
        description: "Given nine letters, try to magic up the longest word you can!",
        productId: process.env.REACT_APP_ANAGRAMMAGIC_PID,
        price: 6.99,
        gameURL: process.env.REACT_APP_ANAGRAMMAGIC_URL,
        storeSlug: '/shop/anagram-magic',
        iosGameID: 'game.city.anagram',
        androidGameID: 'game.city.anagram',
        gameInfo: {
            minPlayers: 1,
            avgRoundLength: 600,
            avgRoundLengthText: '20 Mins',
            minAge: 8,
            descriptions: [
                {
                    header: "WORD WIZARDS WELCOME",
                    body: "Find the longest words and impress your friends with your immense vocabulary."
                },
                {
                    header: "UNRAVEL THE ANAGRAM",
                    body: "Every game has a bonus 9 letter anagram, conjured up just for you, can you find the word?"
                },
                {
                    header: "BONUS POINTS BONANZA",
                    body: "Rare letters worth extra points and get the longest word for even more. Unleash your inner wordsmith and flex your linguistic muscles!"
                },
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["maths_master", "word_wheel", "scrawl"],
        meta: {
            cardLogo: AnagramMagicCardLogo,
            cardBackground: AnagramMagicBackground,
            cardPriceColour: '#10232B',
            storeBackground: AnagramMagicBackground,
            storeLogo: AnagramMagicLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#0e5e87',
            gameMenuTextColour: '#002026',
            previewImages: {
                mobile1: AnagramMagicMobilePreview1,
                mobile2: AnagramMagicMobilePreview2,
                desktop1: AnagramMagicDesktopPreview1,
                desktop2: AnagramMagicDesktopPreview2,
            },
            tinyCard: AnagramMagicTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age8Black,
        },
        pricing: {
            gb: {
                raw: 6.99,
                display: "\u00A36.99",
                currency: "\u00A3"
            },
            us: {
                raw: 9.99,
                display: "\u00249.99",
                currency: "\u0024"
            },
            au: {
                raw: 14.99,
                display: "\u002414.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 7.99,
                display: "\u00A37.99",
                currency: "\u00A3"
            },
            us: {
                raw: 10.99,
                display: "\u002410.99",
                currency: "\u0024"
            },
            au: {
                raw: 16.99,
                display: "\u002416.99",
                currency: "\u0024"
            }
        }
    },
    //Maths master
    {
        type: "Game",
        name: "Maths Master",
        pack: 2,
        gameId: "maths_master",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        logo: MathsMasterLogo,
        description: "You have a target and six numbers, get as close as possible!",
        productId: process.env.REACT_APP_MATHSMASTER_PID,
        price: 6.99,
        gameURL: process.env.REACT_APP_MATHSMASTER_URL,
        storeSlug: '/shop/maths-master',
        iosGameID: 'game.city.maths',
        androidGameID: 'game.city.maths',
        gameInfo: {
            minPlayers: 1,
            avgRoundLength: 600,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "MATH MADNESS",
                    body: "Have you've got what it takes to be a Maths Master? Sharpen your pencils and your wits."
                },
                {
                    header: "THE NUMBERS DON'T LIE",
                    body: "Battle it out with friends and foes alike. Who will rise to the top and become the ultimate number cruncher?"
                },
                {
                    header: "RISING CHALLENGE",
                    body: "Can you keep up as the difficulty increases and prove you're the ultimate maths whiz? Step up, stay sharp, and master the numbers!"
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["anagram_magic", "word_wheel", "scrawl"],
        meta: {
            cardLogo: MathsMasterCardLogo,
            cardBackground: MathsMasterBackground,
            cardPriceColour: '#10232B',
            storeBackground: MathsMasterBackground,
            storeLogo: MathsMasterLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#0e6f87',
            gameMenuTextColour: '#000000',
            previewImages: {
                mobile1: MathsMasterMobilePreview1,
                mobile2: MathsMasterMobilePreview2,
                desktop1: MathsMasterDesktopPreview1,
                desktop2: MathsMasterDesktopPreview2,
            },
            tinyCard: MathsMasterTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age8Black,
        },
        pricing: {
            gb: {
                raw: 6.99,
                display: "\u00A36.99",
                currency: "\u00A3"
            },
            us: {
                raw: 9.99,
                display: "\u00249.99",
                currency: "\u0024"
            },
            au: {
                raw: 14.99,
                display: "\u002414.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 7.99,
                display: "\u00A37.99",
                currency: "\u00A3"
            },
            us: {
                raw: 10.99,
                display: "\u002410.99",
                currency: "\u0024"
            },
            au: {
                raw: 16.99,
                display: "\u002416.99",
                currency: "\u0024"
            }
        }
    },
    //Word wheel
    {
        type: "Game",
        name: "Word Wheel",
        pack: 2,
        gameId: "word_wheel",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        logo: WordWheelLogo,
        description: "Craft words using the central letter and show your linguistic finesse!",
        productId: process.env.REACT_APP_WORDWHEEL_PID,
        price: 6.99,
        gameURL: process.env.REACT_APP_WORDWHEEL_URL,
        storeSlug: '/shop/word-wheel',
        iosGameID: 'game.city.word',
        androidGameID: 'game.city.word',
        gameInfo: {
            minPlayers: 1,
            avgRoundLength: 600,
            avgRoundLengthText: '20 mins',
            minAge: 8,
            descriptions: [
                {
                    header: "THE WHEEL OF WORDCRAFT",
                    body: "Test your word prowess and craft words that revolve around the central letter and showcase your linguistic finesse."
                },
                {
                    header: "ITS A WORD WHEEL RIVALRY",
                    body: "Challenge your friends to a word wheel battle! In this fast pace spelling game!"
                },
                {
                    header: "MAXED OUT WORDPLAY",
                    body: "Score big with longer words! But just remember your against the clock."
                }
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["anagram_magic", "maths_master", "scrawl"],
        meta: {
            cardLogo: WordWheelCardLogo,
            cardBackground: WordWheelBackground,
            cardPriceColour: '#10232B',
            storeBackground: WordWheelBackground,
            storeLogo: WordWheelLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#703499',
            gameMenuTextColour: '#000000',
            previewImages: {
                mobile1: WordWheelMobilePreview1,
                mobile2: WordWheelMobilePreview2,
                desktop1: WordWheelDesktopPreview1,
                desktop2: WordWheelDesktopPreview2,
            },
            tinyCard: WordWheelTinyCard,
            iconTheme: "dark",
            ageRatingIcon: age8Black,
        },
        pricing: {
            gb: {
                raw: 6.99,
                display: "\u00A36.99",
                currency: "\u00A3"
            },
            us: {
                raw: 9.99,
                display: "\u00249.99",
                currency: "\u0024"
            },
            au: {
                raw: 14.99,
                display: "\u002414.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 7.99,
                display: "\u00A37.99",
                currency: "\u00A3"
            },
            us: {
                raw: 10.99,
                display: "\u002410.99",
                currency: "\u0024"
            },
            au: {
                raw: 16.99,
                display: "\u002416.99",
                currency: "\u0024"
            }
        }
    },
    //Can of squirms
    {
        type: "Game",
        name: "Can of Squirms",
        pack: 1,
        gameId: "can_of_squirms",
        supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
        enabled: false,
        logo: SquirmsLogo,
        description: "Awkward questions that you \ncan't un-ask!",
        productId: process.env.REACT_APP_COS_PID,
        price: 9.99,
        gameURL: process.env.REACT_APP_COS_URL,
        storeSlug: '/shop/can-of-squirms',
        iosGameID: 'game.city.squirms',
        androidGameID: 'game.city.squirms',
        gameInfo: {
            minPlayers: 3,
            avgRoundLengthText: '20 mins',
            minAge: 14,
            descriptions: [
                {
                    header: "Cult-starter, drug lord, occasional deviant",
                    body: "Facing some seriously awkward questions, two players go head-to-head. They have to decide who best fits the answer to the question - without conferring."
                },
                {
                    header: "Place your bets",
                    body: "Meanwhile, the other teams are placing side bets: will this pair agree or disagree?"
                },
                //{
                //    header: "One Word Can Give You Away",
                //    body: "Can of Squirms is the ultimate party game for people who are not easily offended. Play it as a drinking game for reduced awkwardness, or stone cold sober to feel the full power of the squirm."
                //}
            ],
            cornerBanner: {
                text: "SALE",
                colour: "#E63946",
                shopOnly: true
            }
        },
        addonIds: [],
        gameUpsellIds: ["herd_mentality", "chameleon", "scrawl"],
        meta: {
            cardLogo: SquirmsCardLogo,
            cardBackground: SquirmsCardBackground,
            cardPriceColour: '#10232B',
            storeBackground: SquirmsStoreBackground,
            storeBackgroundColour: '#04FF79',
            storeLogo: SquirmsStoreLogo,
            storeInfoBackground: '#FFFFFF',
            storeAccentColour: '#212B3D',
            gameMenuTextColour: '#ffffff',
            gameMenuBackgroundColour: '#202B3E',
            previewImages: {
                mobile1: SquirmsMobilePreview1,
                mobile2: SquirmsMobilePreview2,
                desktop1: SquirmsDesktopPreview1,
                desktop2: SquirmsDesktopPreview2,
            },
            tinyCard: SquirmsTinyCard,
            iconTheme: "light",
            ageRatingIcon: age14White,
        },
        pricing: {
            gb: {
                raw: 8.99,
                display: "\u00A38.99",
                currency: "\u00A3"
            },
            us: {
                raw: 12.99,
                display: "\u002412.99",
                currency: "\u0024"
            },
            au: {
                raw: 17.99,
                display: "\u002417.99",
                currency: "\u0024"
            }
        },
        oldPricing: {
            gb: {
                raw: 9.99,
                display: "\u00A39.99",
                currency: "\u00A3"
            },
            us: {
                raw: 14.99,
                display: "\u002414.99",
                currency: "\u0024"
            },
            au: {
                raw: 19.99,
                display: "\u002419.99",
                currency: "\u0024"
            }
        }
    },
];

export default GameList;